module.exports = {"id":"212432","name":"Jo Hyeon Woo","rating":"75","photo":"./data/images/photos/2/212432.png","club":{"name":"Daegu FC","logo":"./data/images/clubs/DaeguFC.png"},"positions":["G"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/JoHyeonWoo0.json
// module id = 2024
// module chunks = 0